import "../app";
import { WebLink, HTTPMethod } from "../models/base"

export interface IFqsResult {
    _embedded: IIdentifiable[];
    _actions?: { [groupname: string]: { [name: string]: { href: string, method?: HTTPMethod } } };
    _curies: { name: string, href: string }[];
}

export type ActionLinkAction<T, D, P> = (data?: D, urlparams?: { [key: string]: P }) => ng.IPromise<T>;

export interface IIdentityLink extends WebLink {
    fullHref: string;
    equals(link: WebLink): boolean;
}

export interface IResourceLink extends IIdentityLink {
    ref: string;
    _ref: string;
}

export interface IIdentifiable {
    id: IIdentityLink;
}
export interface IResource extends IIdentifiable {
    id: IResourceLink;
}

export interface IIdentityResolver<T> extends IIdentityLink {
    value: angular.IPromise<T & IIdentifiable>;
}

export interface IResourceResolver<T> extends IIdentityResolver<T>, IResourceLink {
    value: angular.IPromise<T & IResource>;
}

export interface IIdentifiableOf<T> extends IIdentifiable {
    id: IIdentityResolver<T>;
}

export interface IResourceOf<T> extends IIdentifiableOf<T>, IResource {
    id: IResourceResolver<T>;
}

export interface IIdentifiableCollection extends IIdentifiable {
    items: any[]
}

export interface IIdentifiableCollectionOf<T> extends IIdentifiableCollection {
    items: T[]
}

export interface IIdentifiablePagedCollection extends IIdentifiableCollection {
    page: number
    pageCount?: number
    prev?: IIdentityLink
    next?: IIdentityLink
    first?: IIdentityLink
    last?: IIdentityLink
}

export interface IIdentifiablePagedCollectionOf<T> extends IIdentifiableCollectionOf<T>, IIdentifiablePagedCollection {
    items: T[]
}

export interface CollectionResult<T> extends IIdentifiableCollectionOf<T> {
    page: number;
    pageCount: number;
    count: number;
}

export type IIdentifiableCollectionProperty = IIdentifiableCollection | IIdentityResolver<IIdentifiableCollection>

export type IIdentifiableCollectionPropertyOf<T> = IIdentifiableCollectionOf<T> | IIdentityResolver<IIdentifiableCollectionOf<T>>

export type IIdentifiablePagedCollectionProperty = IIdentifiablePagedCollection | IIdentityResolver<IIdentifiablePagedCollection>

export type IIdentifiablePagedCollectionPropertyOf<T> = IIdentifiablePagedCollectionOf<T> | IIdentityResolver<IIdentifiablePagedCollectionOf<T>>

